// External libraries
import { useEffect } from 'react';
import { isFunction } from '@checkout/react-components';

// Internal modules
import { $logger } from '../logger';

export const useOnMount = onMount => {
  if (!isFunction(onMount)) {
    $logger.error('on_mount_must_be_a_function');
  }

  useEffect(onMount, []);
};
